/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import htmlToDraft from 'html-to-draftjs';
import { List } from 'immutable';
import {
  Modifier,
  EditorState,
  // eslint-disable-next-line import/no-extraneous-dependencies
} from 'draft-js';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotLegacyContent = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'LEGACY_CONTENT',
]);

const isNotTextOrBoth = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'content_mode',
  (value) => value && !['text', 'both'].includes(value),
]);

const isNotImageOrBoth = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'content_mode',
  (value) => !value || !['image', 'both'].includes(value),
]);

const isNotBoth = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'content_mode',
  (value) => !value || value !== 'both',
]);

export default [
  ...[
    getFilterWithCol(['FieldRadio', {
      name: 'content_mode',
      label: null,
      initialValue: 'text',
      choices: [
        { value: 'text', label: 'Text' },
        { value: 'image', label: 'Media' },
        { value: 'both', label: 'Both' },
      ],
      block: true,
    }], 24),
    getFilterWithCol(['FieldUploadRefsHorizontal', {
      name: 'content_image',
      label: null,
      maxCount: 1,
      accept: 'image/jpg,image/jpeg,image/png,image/webp',
      transformations: [
        ['GM', { command: 'compress', maxWidth: 2400 }],
        ['GM', { command: 'webp' }],
      ],
      listType: 'picture',
      uploadLabel: 'Upload Image',
      skip: [isNotImageOrBoth],
    }], 12),
    getFilterWithCol(['FieldUploadRefsHorizontal', {
      name: 'content_video',
      label: null,
      maxCount: 1,
      accept: 'video/mp4',
      transformations: [],
      listType: 'picture',
      uploadLabel: 'Upload Video',
      skip: [isNotImageOrBoth],
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'content_imageWidth',
      type: 'number',
      align: 'right',
      label: null,
      prefix: 'Media Width',
      addonAfter: '%',
      initialValue: 50,
      skip: [isNotImageOrBoth],
      rules: [
        [(config = {}) => ({
          type: 'number',
          min: 0,
          max: 100,
          message: 'Image width must be a number between 0 and 100',
          ...config,
        })],
      ],
    }], 24),
    getFilterWithCol(['FieldRadio', {
      name: 'content_alignImage',
      label: null,
      skip: [isNotBoth],
      initialValue: 'left',
      choices: [
        { value: 'left', label: 'Image Left' },
        { value: 'right', label: 'Image Right' },
      ],
      block: true,
    }], 24),
    getFilterWithCol(['FieldText', {
      name: 'content_title',
      label: null,
      prefix: 'Title:',
      skip: [isNotTextOrBoth],
      i18nTranslatable: true,
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'content_subtitle',
      label: null,
      prefix: 'Subtitle:',
      skip: [isNotTextOrBoth],
      i18nTranslatable: true,
    }], 12),
    getFilterWithCol(['FieldWYSIWYG', {
      name: 'content_content',
      label: null,
      placeholder: 'Content',
      skip: [isNotTextOrBoth],
      i18nTranslatable: true,
      getToolbarConfig: props => ({
        ...props.toolbarConfig,
        inline: {
          ...props.toolbarConfig.inline,
          options: [
            ...props.toolbarConfig.inline.options,
            'superscript',
            'subscript',
          ],
        },
        options: props.toolbarConfig.options.filter(
          option => !['link'].includes(option)
        ),
        image: {
          ...props.toolbarConfig.image,
          inputAccept: 'image/jpeg,image/jpg,image/png',
        },
      }),
      editorConfig: {
        handlePastedText: (text, html, editorState, onChange) => {
          const contentBlock = htmlToDraft(
            (text || '')
            .trim()
            .split(/\s*\n+\s*/g)
            .map(blockText => `<p>${blockText}</p>`)
            .join('')
          );
          let contentState = editorState.getCurrentContent();
          contentBlock.entityMap.forEach((value, key) => {
            contentState = contentState.mergeEntityData(key, value);
          });
          onChange(EditorState.push(
            editorState,
            Modifier.replaceWithFragment(
              contentState,
              editorState.getSelection(),
              new List(contentBlock.contentBlocks)
            ),
            'insert-characters',
          ));
          return true;
        },
      },
    }], 24),
    getFilterWithCol(['FieldText', {
      name: 'content_buttonLabel',
      label: null,
      prefix: 'Button Label:',
      skip: [isNotTextOrBoth],
      i18nTranslatable: true,
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'content_buttonLink',
      label: null,
      prefix: 'Button Link:',
      skip: [isNotTextOrBoth],
    }], 12),
    getFilterWithCol(['FieldRadio', {
      name: 'content_alignContent',
      label: null,
      initialValue: 'left',
      choices: [
        { value: 'left', label: 'Text Left' },
        { value: 'center', label: 'Text Center' },
        { value: 'right', label: 'Text Right' },
      ],
      skip: [isNotTextOrBoth],
      block: true,
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotLegacyContent, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
